import { render, staticRenderFns } from "./GemTooltip.vue?vue&type=template&id=f552257e&scoped=true"
import script from "./GemTooltip.vue?vue&type=script&lang=ts"
export * from "./GemTooltip.vue?vue&type=script&lang=ts"
import style0 from "./GemTooltip.vue?vue&type=style&index=0&id=f552257e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f552257e",
  null
  
)

export default component.exports